import React from "react";

interface NavBarProps {
  readonly signInHref: string;
  readonly signUpHref: string;
}

export default function NavBar({ signInHref, signUpHref }: NavBarProps) {
  return (
    <header className="bg-white border-b border-[#d8e0ee] fixed top-0 left-0 right-0 z-50 shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <svg
                viewBox="0 0 64 64"
                className="w-8 h-8"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M10 8c0-3.3 2.7-6 6-6h8v44h18c3.3 0 6 2.7 6 6v6H16c-3.3 0-6-2.7-6-6V8z"
                  fill="#2563EB"
                />
                <rect x="28" y="12" width="14" height="14" rx="4" fill="#2563EB" />
                <rect x="44" y="12" width="14" height="14" rx="4" fill="#2563EB" />
                <rect x="28" y="28" width="14" height="14" rx="4" fill="#2563EB" />
                <path d="M44 28h8l6 6v8h-8a6 6 0 0 1-6-6v-8z" fill="#2563EB" />
              </svg>
            </div>
            <span className="text-lg font-bold text-[#0f1b35]">Liriworks</span>
          </a>

          {/* Nav links */}
          {/* <div className="hidden md:flex items-center gap-6">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm font-medium text-[#405173] hover:text-[#2563eb] transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div> */}

          {/* Auth buttons */}
          <div className="flex items-center gap-2">
            <a
              href={signInHref}
              className="px-4 py-1.5 text-sm font-semibold text-[#2563eb] border border-[#2563eb] rounded-lg hover:bg-[#e9f0ff] transition-colors"
            >
              Sign In
            </a>
            <a
              href={signUpHref}
              className="px-4 py-1.5 text-sm font-semibold text-white bg-[#2563eb] rounded-lg hover:bg-[#1f52c9] transition-colors"
            >
              Sign Up
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}